import TextSent from './TextSent';

export default TextSent;
